<template>
    <div class="stockData" id="depositData">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1">&nbsp;</div>
                <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix" @click.stop="showVipList=false;">
                        <!-- <div class="search">
                            <el-input
                            placeholder="请输入会员手机号码"
                            v-model="memberPhone"
                            clearable>
                            </el-input>
                            <div class="vip-sel" v-if="vipList.length&&showVipList">
                                <ul>
                                    <li @click.stop="selNowVip(item)" v-for="(item,index) in vipList" :key="index">{{item.name}}</li>
                                </ul>
                            </div>
                        </div> -->
                        <!-- <div class="date-filter" v-if="nowType=='STOCK'">
                            <el-date-picker v-model="dateStr" type="date" ref='dateInput' value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="请选择选择日期">
                            </el-date-picker>
                            <i class="iconfont icon-jiantou" @click="$refs.dateInput.handleFocus()"></i>
                        </div> -->
                        <!-- <div class="time-range-filter" v-if="nowType=='TIME_RANGE'">
                            <el-date-picker
                            v-model="startTime"
                            type="datetime"
                            class="dateTime"
                            default-time="00:00:00"
                            placeholder="开始时间">
                            </el-date-picker>
                            <el-date-picker
                            v-model="endTime"
                            type="datetime"
                            class="dateTime"
                            default-time="23:59:59"
                            placeholder="结束时间">
                            </el-date-picker>
                            <span class="types typesSearch" >
                                <span type="button" @click="searchConfirm">查询</span>
                            </span>
                        </div> -->
                        
                        <!--  -->
                        <!-- <div class="type-change" @click="nowType=='STOCK'?nowType='TIME_RANGE':nowType='STOCK'">
                            <span>{{nowType=='STOCK'?'按时间段查询':'按天查询'}}</span>
                        </div> -->
                        
                        <div class="change-type" v-if="searchByWhichType=='dayOrMonth'">
                            <span @click="nowType='STOCK'">仓库</span>
                            <span :class="nowType=='STOCK'?'type-wrap':'type-wrap to-right'" @click="nowType=='STOCK'?nowType='BAR':nowType='STOCK'" >
                                <i @click.stop=""></i>
                            </span>
                            <span @click="nowType='BAR'">吧台</span>
                        </div>
                        <div class="month-filter">
                            <el-date-picker
                            v-model="valueForMonth"
                            value-format="yyyy-MM"
                            format="yyyy 年 MM 月"
                            type="month"
                            class="dateTime"
                            placeholder="选择月">
                            </el-date-picker>
                        </div>
                        <!-- <div class="day-filter" v-if="nowType=='STOCK'&&searchByWhichType=='dayOrMonth'">
                            <el-date-picker
                            v-model="nowDay"
                            value-format="yyyy-MM"
                            format="yyyy 年 MM 月"
                            :picker-options="pickerOptions0"
                            type="month"
                            class="dateTime"
                            placeholder="选择月">
                            </el-date-picker>
                        </div>
                        <div class="time-range-filter" v-if="searchByWhichType=='timeRange'">
                            <el-date-picker
                            v-model="startTime"
                            type="datetime"
                            class="dateTime"
                            default-time="00:00:00"
                            :picker-options="pickerOptionsForTimeRange"
                            placeholder="开始时间">
                            </el-date-picker>
                            <el-date-picker
                            v-model="endTime"
                            type="datetime"
                            class="dateTime"
                            default-time="23:59:59"
                            :picker-options="pickerOptionsForTimeRange"
                            placeholder="结束时间">
                            </el-date-picker>
                        </div> -->
                        <!-- <div class="time-range">
                            <span @click="searchByWhichType=='timeRange'?searchByWhichType='dayOrMonth':searchByWhichType='timeRange'">
                                {{searchByWhichType=="timeRange"?'按日/月形式查询':'按时间段查询'}}
                            </span>
                        </div> -->
                        <span class="types typesSearch">
                            <span type="button" @click="searchConfirm(currentPage - 1)">查询</span>
                        </span>
                    </div>
                </div>
                <div class="HSpace2">&nbsp;</div>
                <div class="tableBox" v-if="nowType=='STOCK'">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:7.5%;color:#2b7fec;border-right:2px solid #ddd;" colspan="7">入库</th>
                                <th style="width:7.5%;color:#2b7fec;" colspan="6">出库</th>
                            </tr>
                            <tr>
                                <th style="width:7.5%">序号</th>
                                <th style="width:7.5%">商品名称</th>
                                <th style="width:7.5%">上月余存</th>
                                <th style="width:7.5%">采购入库</th>
                                <th style="width:7.5%">盘点入库</th>
                                <th style="width:7.5%">调拨入库</th>
                                <th style="width:7.5%;border-right:2px solid #ddd;">吧台退回</th>
                                <th style="width:7.5%">出货至吧台</th>
                                <th style="width:7.5%">盘点出库</th>
                                <th style="width:7.5%">退货出库</th>
                                <th style="width:7.5%">调拨出库</th>
                                <th style="width:7.5%">本月余存</th>
                                <th style="width:7.5%">剩余价值</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:depositList.length>pageSize}">
                                    <tr v-for="(item,ind) in depositList" class="listTr">
                                        <td style="width:7.5%">{{item.skuName?(ind+1):""}}</td>
                                        <td style="width:7.5%" :title="item.skuName">{{item.skuName?(item.skuName):""}}</td>
                                        <td style="width:7.5%">{{item.skuName?(item.lastQty):""}}</td>
                                        <td style="width:7.5%">{{item.skuName?(item.purchaseInQty):""}}</td>
                                        <td style="width:7.5%">{{item.skuName?(item.checkInQty):""}}</td>
                                        <td style="width:7.5%">{{item.skuName?(item.allocationInQty):""}}</td>
                                        <td style="width:7.5%;" :class="item.skuName?'border':''">{{item.skuName?(item.barInQty):""}}</td>
                                        <td style="width:7.5%">{{item.skuName?(item.innerOutQty):""}}</td>
                                        <td style="width:7.5%">{{item.skuName?(item.checkoutQty):""}}</td>
                                        <td style="width:7.5%">{{item.skuName?(item.refundOutQty):""}}</td>
                                        <td style="width:7.5%">{{item.skuName?(item.allocationOutQty):""}}</td>
                                        <td style="width:7.5%">{{item.skuName?(item.nowQty):""}}</td>
                                        <td style="width:7.5%">{{item.skuName?(item.value):""}}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tableBox" v-if="nowType=='BAR'">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:7.5%;color:#2b7fec;border-right:2px solid #ddd;" colspan="7">入库</th>
                                <th style="width:7.5%;color:#2b7fec;" colspan="6">出库</th>
                            </tr>
                            <tr>
                                <th style="width:7.5%">序号</th>
                                <th style="width:7.5%">商品名称</th>
                                <th style="width:7.5%">上月余存</th>
                                <th style="width:7.5%">吧台上架</th>
                                <th style="width:7.5%">仓库至吧台</th>
                                <th style="width:7.5%">盘点入库</th>
                                <th style="width:7.5%;border-right:2px solid #ddd;">退单入库</th>
                                <th style="width:7.5%;">销售出库</th>
                                <th style="width:7.5%">吧台下架</th>
                                <th style="width:7.5%">吧台退回仓库</th>
                                <th style="width:7.5%">盘点出库</th>
                                <th style="width:7.5%">本月余存</th>
                                <th style="width:7.5%">剩余价值</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:depositListForBar.length>pageSize}">
                                    <tr v-for="(item,ind) in depositListForBar" class="listTr">
                                        <td style="width:7.5%">{{item.skuName?(ind+1):""}}</td>
                                        <td style="width:7.5%" :title="item.skuName">{{item.skuName?(item.skuName):""}}</td>
                                        <td style="width:7.5%">{{item.skuName?(item.lastQty):""}}</td>
                                        <td style="width:7.5%">{{item.skuName?(item.innerInQty):""}}</td>
                                        <td style="width:7.5%">{{item.skuName?(item.stockInnerInQty):""}}</td>
                                        <td style="width:7.5%">{{item.skuName?(item.checkInQty):""}}</td>
                                        <td style="width:7.5%;" :class="item.skuName?'border':''">{{item.skuName?(item.refundInQty):""}}</td>
                                        <td style="width:7.5%">{{item.skuName?(item.salesOutQty):""}}</td>
                                        <td style="width:7.5%">{{item.skuName?(item.innerOutQty):""}}</td>
                                        <td style="width:7.5%">{{item.skuName?(item.barOutQty):""}}</td>
                                        <td style="width:7.5%">{{item.skuName?(item.checkoutQty):""}}</td>
                                        <td style="width:7.5%">{{item.skuName?(item.nowQty):""}}</td>
                                        <td style="width:7.5%">{{item.skuName?(item.value):""}}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="pagination">
                    <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper" :total="totalElements">
                    </el-pagination>
                </div> -->
                <!-- 分页器 -->
                <div class="pager flex flex-align-center" style="justify-content: space-between;">
                    <div style="color:red">
                        <span v-if="nowType=='BAR'">总库存剩余数：{{totalInfoForBar.totalCount}} ，总库存价值：{{totalInfoForBar.totalMoney}}</span>
                        <span v-else>总库存剩余数：{{totalInfo.totalCount}} ，总库存价值：{{totalInfo.totalMoney}}</span>
                    </div>
                    <div class="out-excel"><span @click="excel">导出excel</span></div>
                    <!-- <div class="pagerCon clearfix">
                        <div class="pagerBtnBox right">
                            <div class="pagerBtn">
                                <span class="prev flex flex-align-center flex-pack-center left"><i class="el-icon-arrow-left"></i></span>
                                <span class="curPageNumber flex flex-align-center flex-pack-center left">1</span>
                                <span class="next flex flex-align-center flex-pack-center left havePage"><i class="el-icon-arrow-right"></i></span>
                            </div>
                        </div>
                        <div class="curPage flex flex-align-center right">第 1 / 9 条</div>
                        <div class="totalPage flex flex-align-center right">共100条</div>
                    </div> -->
                </div>
            </div>
        </div>
        <el-dialog
        title="修改到期时间"
        :visible.sync="showModify"
        width="30%"
        >
        <div class="end-time">
            <span class="demonstration">请设置到期时间</span>
            <el-date-picker
            v-model="endTimeForThisItem"
            type="datetime"
            placeholder="选择日期时间"
            default-time="12:00:00">
            </el-date-picker>
        </div>
        <div class="modify-btn">
            <button @click.stop="showModify=false">取消</button>
            <button class="sure" @click.stop="modifyThisItem">确定</button>
        </div>
        </el-dialog>
        <table id="scrollBox" style="display:none"> 
        </table>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    import {BASE_URL} from "./../../../../urlConfig/index";
    export default{
        props: ['curStoreId','pageSize'],
        data () {
            return {
                valueForMonth:"",
                vipList:[],
                showVipList:false,
                nowSelVip:{id:""},
                searchPhone:"",//会员搜索手机号
                pickerOptionsForDay: {
                //时间禁用,今天以后的时间禁用。
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    }
                },
                pickerOptionsForTimeRange:{
                   disabledDate(time) {
                    
                    //    let date = (new Date(time));
                    // //    let dateStr = date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate();
                    // //    let newDate = new Date(dateStr).getTime();
                    // //    let newDateForNextMonth = new Date(date.getFullYear(),(date.getMonth()+1),0).getTime();
                    // //    return time.getTime() < newDate || time.getTime() > newDateForNextMonth;
                    //     let curDate = (new Date()).getTime();
                    //     let three = 30 * 24 * 3600 * 1000;
                    //     let threeDays = curDate - three;
                    //     return time.getTime() > Date.now() || time.getTime() < threeDays;
                    } 
                },
                nowDay:'',//当前日期
                searchByWhichType:"dayOrMonth",//按照时间段或者是日月报的形式查询，dayOrMonth,timeRange
                curSelItem:{},
                endTimeForThisItem:"",
                showModify:false,
                statusData:{
                    0:'正常',
                    1:'核销',
                    2:'过期',
                },
                memberPhone:"",
                depositList: [], // 核销详情
                depositListForBar:[],
                nowType:"STOCK",
                startTime:'',//按时间段查询的起始时间
                endTime:'',//按时间段查询的结束时间
                pickerOptions: {
                    disabledDate(time) {
                    return time.getTime() > Date.now();
                    }
                },
                dateStr: new Date().Format("yyyy-MM-dd"),
                currentPage: 1,
                totalElements: 0, //数据总条数
                canClick:true,
                totalInfo:{},
                totalInfoForBar:{}
            }
        },
        watch: {
            dateStr(val) {
                console.log(new Date(val).Format("yyyy-MM-dd"));
                let nowDate = new Date(val).Format("yyyy-MM-dd");
                this.dateStr = nowDate;
                this.getrDepositList(0, "");
            },
            showModify(val){
                if(!val){
                    this.curSelItem = {};
                    this.endTimeForThisItem = "";
                }
            },
            memberPhone(val){
                console.log(val)
                if(val == this.nowSelVip.mobile){
                    this.showVipList = false;
                    return;
                }
                if(val==""){
                    this.showVipList = false;
                    this.nowSelVip={id:""};
                    return;
                }
                this.getVipList(val);
            }
        },
        methods: {
            excel(){
                let data = this.nowType=="STOCK"?this.depositList:this.depositListForBar;
                console.log(data)
                // return;
                let html;
                if(this.nowType=="STOCK"){
                    html = '<tr>'+  
                        '<td style="font-size:18px">商品名称</td>'+
                        '<td style="font-size:18px">上月余存</td>'+
                        '<td style="font-size:18px">采购入库</td>'+ 
                        '<td style="font-size:18px">盘点入库</td>'+ 
                        '<td style="font-size:18px">调拨入库</td>'+
                        '<td style="font-size:18px">吧台退回</td>'+
                        '<td style="font-size:18px">出货至吧台</td>'+
                        '<td style="font-size:18px">盘点出库</td>'+
                        '<td style="font-size:18px">退货出库</td>'+
                        '<td style="font-size:18px">调拨出库</td>'+
                        '<td style="font-size:18px">本月余存</td>'+
                        '<td style="font-size:18px">剩余价值</td>'+
                    '</tr>';
                }else{
                   html = '<tr>'+  
                       '<td style="font-size:18px">商品名称</td>'+
                        '<td style="font-size:18px">上月余存</td>'+
                        '<td style="font-size:18px">吧台上架</td>'+ 
                        '<td style="font-size:18px">仓库至吧台</td>'+ 
                        '<td style="font-size:18px">盘点入库</td>'+
                        '<td style="font-size:18px">退单入库</td>'+
                        '<td style="font-size:18px">销售出库</td>'+
                        '<td style="font-size:18px">吧台下架</td>'+
                        '<td style="font-size:18px">吧台退回仓库</td>'+
                        '<td style="font-size:18px">盘点出库</td>'+
                        '<td style="font-size:18px">本月余存</td>'+
                        '<td style="font-size:18px">剩余价值</td>'+
                    '</tr>'; 
                }
                if(this.nowType=="STOCK"){
                    for(let i=0;i<data.length;i++){
                        if ( !data[i].skuName ) {
                            continue;
                        }
                        html  +='<tr>'+
                                    '<td>'+data[i].skuName+'</td>'+
                                    '<td>'+data[i].lastQty+'</td>'+ 
                                    '<td>'+data[i].purchaseInQty+'</td>'+ 
                                    '<td>'+data[i].checkInQty+'</td>'+ 
                                    '<td>'+data[i].allocationInQty+'</td>'+ 
                                    '<td>'+data[i].barInQty+'</td>'+ 
                                    '<td>'+data[i].innerOutQty+'</td>'+ 
                                    '<td>'+data[i].checkoutQty+'</td>'+ 
                                    '<td>'+data[i].refundOutQty+'</td>'+ 
                                    '<td>'+data[i].allocationOutQty+'</td>'+ 
                                    '<td>'+data[i].nowQty+'</td>'+ 
                                    '<td>'+(data[i].value)+'</td>'+ 
                                '</tr>'
                    }
                }else{
                    for(let i=0;i<data.length;i++){
                        if ( !data[i].skuName ) {
                            continue;
                        }
                        html  +='<tr>'+
                                    '<td>'+data[i].skuName+'</td>'+
                                    '<td>'+data[i].lastQty+'</td>'+ 
                                    '<td>'+data[i].innerInQty+'</td>'+ 
                                    '<td>'+data[i].stockInnerInQty+'</td>'+ 
                                    '<td>'+data[i].checkInQty+'</td>'+ 
                                    '<td>'+data[i].refundInQty+'</td>'+ 
                                    '<td>'+data[i].salesOutQty+'</td>'+ 
                                    '<td>'+data[i].innerOutQty+'</td>'+ 
                                    '<td>'+data[i].barOutQty+'</td>'+ 
                                    '<td>'+data[i].checkoutQty+'</td>'+ 
                                    '<td>'+data[i].nowQty+'</td>'+ 
                                    '<td>'+(data[i].value)+'</td>'+ 
                                '</tr>'
                    }
                }
                
                if(this.nowType=="STOCK"){
                    html  +='<tr>'+
                            '<td> </td>'+
                            '<td> </td>'+ 
                            '<td> </td>'+ 
                            '<td> </td>'+ 
                            '<td> </td>'+ 
                            '<td>总库存剩余数:'+this.totalInfo.totalCount+'</td>'+ 
                            '<td>总库存价值:'+this.totalInfo.totalMoney+'</td>'+ 
                        '</tr>'
                }else{
                     html  +='<tr>'+
                            '<td> </td>'+
                            '<td> </td>'+ 
                            '<td> </td>'+ 
                            '<td> </td>'+ 
                            '<td> </td>'+ 
                            '<td>总库存剩余数:'+this.totalInfoForBar.totalCount+'</td>'+ 
                            '<td>总库存价值:'+this.totalInfoForBar.totalMoney+'</td>'+ 
                        '</tr>'
                }
                document.getElementById('scrollBox').innerHTML = html;
                window.method5(scrollBox);
            },
            selNowVip(item){
                this.nowSelVip = item;
                this.memberPhone = item.mobile;
                this.vipList = [];
            },
             getVipList(val){
                this.$http({
                    url:BASE_URL+"/v1/pos/members",
                    method:"GET",
                    params:{
                        storeId:this.curStoreId,
                        q:val
                    }
                }).then(res=>{
                    this.vipList = res.data;
                    this.showVipList = true;
                });
            },
            modifyThisItem(){
                if(!this.endTimeForThisItem || this.endTimeForThisItem == ""){
                    this.$message({
                        message: '请选择到期时间',
                        customClass: 'error'
                    })
                    return;
                }
                this.$http({
                    url:"update-postage",
                    method:"POST",
                    data:{
                        id:this.curSelItem.id,
                        endTime:new Date(this.endTimeForThisItem).Format("yyyy-MM-dd hh:mm:ss")
                    }
                }).then(res=>{
                    if(res.data.code == 200){
                        this.$message({
                            message: res.data.msg,
                            customClass: 'success'
                        })
                        this.showModify = false;
                        this.currentPage = 1;
                        if(this.memberPhone!=""){
                            this.search();
                            return;
                        }
                        // this.getrDepositList(0,"");
                        let date = new Date(this.nowDay).Format("yyyy-MM-dd");
                        let dateForMonth = new Date(this.valueForMonth).Format("yyyy-MM");
                        if(this.searchByWhichType === "dayOrMonth"){
                        if(this.nowType=='BAR'){
                            if(!this.valueForMonth){
                                this.$message({
                                    message: '请选择查询时间',
                                    customClass: 'error'
                                })
                                return;

                            }
                            if(dateForMonth){
                                this.getrDepositList(0,dateForMonth,"MONTH",this.memberPhone);
                                // this.getWordData();
                                // this.getSales();
                            } else {
                                this.$message({
                                    message: '请选择查询时间',
                                    customClass: 'error'
                                })
                            }
                        }else{
                            if(!this.nowDay){
                                this.$message({
                                    message: '请选择查询时间',
                                    customClass: 'error'
                                })
                                return;

                            }
                            if(date){
                                this.getrDepositList(0,date,"STOCK",this.memberPhone);
                                // this.getWordData();
                                // this.getSales();
                            } else {
                                this.$message({
                                    message: '请选择查询时间',
                                    customClass: 'error'
                                })
                            }
                        }
                    }else{
                        if(this.startTime!=='' && this.endTime!==''){
                            if(new Date(this.startTime)>new Date(this.endTime)){
                                this.$message({
                                    message: '结束时间不能比开始时间小',
                                    customClass: 'error'
                                })
                                return;
                            }
                            let days = 1000*60*60*24*45;
                            if(new Date(this.endTime) - new Date(this.startTime) > days){
                                this.$message({
                                    message: '查询时间段最多45天',
                                    customClass: 'error'
                                });
                                return;
                            }
                            //起止时间
                            let startTime = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                            let endTime = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                            this.getrDepositList(0,{startTime,endTime},"ELSE",this.memberPhone);
                        }else{
                            this.$message({
                                message: '请选择查询时间段',
                                customClass: 'error'
                            })
                            return;
                        }
                    }
                        return;
                    }else if(res.data.code == 400){
                        this.$message({
                            message: res.data.msg,
                            customClass: 'error'
                        })
                        return;
                    }
                })
            },
            modify(item){
                this.curSelItem = item;
                this.showModify = true;
            },
            search(){
                if(this.memberPhone==""){
                    this.getrDepositList(0,"");
                    return;
                }
                if(!/^\d{11}$/.test(this.memberPhone)){
                    this.$message({
                        message: '手机号输入有误',
                        customClass: 'error'
                    })
                    return;
                }
                this.getrDepositList(0,this.memberPhone);
            },
            //分页方法
            handleCurrentChange(val) {
                if(this.memberPhone!=""&&(!/^\d{11}$/.test(this.memberPhone))){
                    this.$message({
                        message: '手机号输入有误',
                        customClass: 'error'
                    })
                    return;
                }
                console.log(`当前页: ${val}`);
                console.log(this.dateStr);
                this.searchConfirm(val - 1);
            },
            // 搜索
            searchConfirm: function (page) {
                if(this.memberPhone!=""&&(!/^\d{11}$/.test(this.memberPhone))){
                    this.$message({
                        message: '手机号输入有误',
                        customClass: 'error'
                    })
                    return;
                }
                
                let date = new Date(this.nowDay).Format("yyyy-MM-dd");
                let dateForMonth = new Date(this.valueForMonth).Format("yyyy-MM");
                // 
                // let timeStr = new Date(date).getTime() + "-" + new Date(date).getTime();
                // let nowTime = new Date().getTime();
                // if(!(this.$canClickSelect("depositData",timeStr,nowTime))){
                //     this.$message({
                //         message: '5秒内禁止重复查询数据',
                //         customClass: 'error'
                //     });
                //     return;
                // }
                //
                
                if(this.searchByWhichType === "dayOrMonth"){
                    if(this.nowType=='BAR'){
                        if(!this.valueForMonth){
                            this.$message({
                                message: '请选择查询时间',
                                customClass: 'error'
                            })
                            return;

                        }
                        if(dateForMonth){
                            this.getrDepositList(page,dateForMonth,"MONTH",this.memberPhone);
                            // this.getWordData();
                            // this.getSales();
                        } else {
                            this.$message({
                                message: '请选择查询时间',
                                customClass: 'error'
                            })
                        }
                    }else{
                        if(!this.nowDay){
                            this.$message({
                                message: '请选择查询时间',
                                customClass: 'error'
                            })
                            return;

                        }
                        if(date){
                            this.getrDepositList(page,date,"STOCK",this.memberPhone);
                            // this.getWordData();
                            // this.getSales();
                        } else {
                            this.$message({
                                message: '请选择查询时间',
                                customClass: 'error'
                            })
                        }
                    }
                }else{
                    if(this.startTime!=='' && this.endTime!==''){
                        if(new Date(this.startTime)>new Date(this.endTime)){
                            this.$message({
                                message: '结束时间不能比开始时间小',
                                customClass: 'error'
                            })
                            return;
                        }
                        let days = 1000*60*60*24*45;
                        if(new Date(this.endTime) - new Date(this.startTime) > days){
                            this.$message({
                                message: '查询时间段最多45天',
                                customClass: 'error'
                            });
                            return;
                        }
                        //起止时间
                        let startTime = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                        let endTime = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                        this.getrDepositList(page,{startTime,endTime},"ELSE",this.memberPhone);
                    }else{
                        this.$message({
                            message: '请选择查询时间段',
                            customClass: 'error'
                        })
                        return;
                    }
                }
            },
            lastTime(year, month) {
                if (String(month).length <= 1) {
                    month = "0" + month;
                }
                let day = new Date(year, month, 0);
                let lastdate = year + "-" + month + "-" + day.getDate();
                let lastTime = lastdate + " 23:59:59";
                // return new Date(lastTime).getTime() / 1000;
                return lastTime;
            },
            // 获取核销详情
            getrDepositList: function (page,date,source,mobile) {
                // let params;
                // if(type == "STOCK"){
                //     params = {
                //         storeId:this.curStoreId,
                //         time:date,
                //         type,
                //         page,
                //         size: this.pageSize,
                //     }
                // }else{
                //     let begin = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                //     let end = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                //     params = {
                //         storeId:this.curStoreId,
                //         begin,
                //         end,
                //         type,
                //         page,
                //         size: this.pageSize,
                //     }
                // }
                let params;
                if(this.searchByWhichType === "dayOrMonth"){
                    if(source=="STOCK"){
                        params = {
                            storeId:this.curStoreId,
                            time:date,
                            source,
                            mobile,
                            page,
                            size: this.pageSize,
                        }
                    }else{
                        let dateObj = new Date(date);
                        let year = dateObj.getFullYear();
                        let month = `${year}-${dateObj.getMonth() + 1}`;
                        params = {
                            storeId:this.curStoreId,
                            month,
                            source,
                            mobile,
                            page,
                            size: this.pageSize,
                        }
                    }
                }else{
                    let dateObj = date;
                    let startTime = date.startTime;
                    let endTime = date.endTime;
                    params = {
                        storeId:this.curStoreId,
                        from:startTime,
                        to:endTime,
                        source,
                        mobile,
                        page,
                        size: this.pageSize,
                    }
                }
                let startTime = `${new Date(this.valueForMonth).Format("yyyy-MM")}-01 00:00:00`;
                let year = new Date(this.valueForMonth).getFullYear();
                let month = new Date(this.valueForMonth).getMonth() + 1;
                let endTime = this.lastTime(year,month);
                let nowMoth = new Date().getMonth() + 1;
                let data = {
                    storeId:this.curStoreId,
                    beginTime:startTime,
                    endTime,
                    type:this.nowType=="STOCK"?2:1
                    // type:nowMoth==month?0:1,
                    // level:this.nowType=="STOCK"?"WAREHOUSE":"BAR"
                }
                console.log(data);
                if(!this.canClick){
                    return;
                }
                this.canClick = false;
                this.$http({
                    url:"product/inv/count",
                    method:"GET",
                    params:data
                }).then(res=>{
                    setTimeout(()=>{
                        this.canClick = true;
                    },500);
                    let body = res.data;
                    if(this.nowType=="STOCK"){
                        this.depositList = body;
                        let totalCount = 0;
                        let totalMoney = 0;
                        for(let i=0;i<body.length;i++){
                            totalCount+=Number(body[i].nowQty);
                            totalMoney+=Number(body[i].value);
                        }
                        this.totalInfo = {
                            totalCount,
                            totalMoney
                        }
                    }else{
                        this.depositListForBar = body;
                        let totalCount = 0;
                        let totalMoney = 0;
                        for(let i=0;i<body.length;i++){
                            totalCount+=Number(body[i].nowQty);
                            totalMoney+=Number(body[i].value);
                        }
                        this.totalInfoForBar = {
                            totalCount,
                            totalMoney
                        }
                    }
                    let number = this.pageSize - body.length;
                    // this.totalElements = body.totalElements;
                    if ( number > 0 ) {
                        for (let i = 0; i < number; i++) {
                            if(this.nowType=="STOCK"){
                                this.depositList.push({
                                    id: '', // 员工id
                                    name: '', // 员工姓名
                                    code: '', // 编号
                                    mobile: '', // 手机
                                    groupName: '' // 岗位id
                                });
                            }else{
                                this.depositListForBar.push({
                                    id: '', // 员工id
                                    name: '', // 员工姓名
                                    code: '', // 编号
                                    mobile: '', // 手机
                                    groupName: '' // 岗位id
                                });
                            }
                        }
                    }
                }).catch((err) => {
                    setTimeout(()=>{
                        this.canClick = true;
                    },500);
                });
            },
        },
        created: function () {
            for (let i = 0; i < this.pageSize; i++) {
                this.depositList.push({
                    id: '', // 员工id
                    name: '', // 员工姓名
                    code: '', // 编号
                    mobile: '', // 手机
                    groupName: '' // 岗位id
                })
            }
            // this.getrDepositList(page,date,source,mobile);
        },
        activated: function () {
            this.nowDay = new Date();
            this.valueForMonth = new Date();
            
            // 改变关闭样式
            $(document).ready(()=>{
                $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
            });
            this.searchConfirm(0);
        }
    }
</script>
<style lang="scss">
    @import '../../../../../static/css/common.scss';
    @import '../../../tableTemplate/tableTem.scss';
    @import '../../../tableTemplate/el-dialog.scss';
    @import "./stockData.scss";
</style>



// WEBPACK FOOTER //
// stockData.vue?0b89b7fd